







































import {
    Component, Vue, Watch, Model, Prop,
} from 'vue-property-decorator';
import moment, { Moment } from 'moment';

@Component
export default class TimePicker extends Vue {
    @Model('input') public value!: string | null;

    @Prop({ default: '00:00' }) public default!: string;

    public menu = false;

    public onMenuInput(event: any) {
        this.menu = event;
    }

    public onClickClear() {
        this.$emit('input', this.default);
    }

    public onInput(event: any) {
        this.$emit('input', event);
    }
}
